import React from "react";
import { connect } from "react-redux";
import { browserHistory as history } from "react-router";
import {
  Spinner,
  SpinnerSize,
  Dialog,
  DialogFooter,
  SelectionMode,
  FocusZone,
  DetailsList,
  DetailsRow,
  DialogType,
  Dropdown,
  TagPicker,
  PrimaryButton,
  DefaultButton,
  Pivot,
  PivotItem,
  PivotLinkSize,
  TextField,
  DatePicker,
} from "office-ui-fabric-react";
import axios from "axios";
import InfiniteScroll from "react-infinite-scroller";
import _ from "lodash";
import moment from "moment";
import config from "../config";
import StatusBar from "./common/StatusBar";
import { CENTRAL_DASHBOARD_COLUMNS } from "../constants/tableConfig";
import {
  LEAD_CATEGORY_LIST,
  PATIENT_ASSIGNMENT_LIST,
} from "../constants/lists";
import { PATIENT_ASSIGNMENT, USER_TYPE, LEAD_STATUS } from "../constants/enums";
import ROUTE from "../constants/routes";
import MoveToWaitModal from "./common/MoveToWaitModal";

import LeadForm from "./common/LeadForm";
import CustomerAddEditForm from "./common/CustomerAddEditForm";
import StartEndDateFilter from "./common/StartEndDateFilter";


const PAGE_PA_LIST = PATIENT_ASSIGNMENT_LIST.filter((opt) =>
  [
    PATIENT_ASSIGNMENT.HOME_HEALTH,
    PATIENT_ASSIGNMENT.HOSPICE,
    PATIENT_ASSIGNMENT.CLINIC,
    PATIENT_ASSIGNMENT.SIGN_UP,
    PATIENT_ASSIGNMENT.PHARMACY,
    PATIENT_ASSIGNMENT.ADHC,
    PATIENT_ASSIGNMENT.NOT_INTERESTED,
  ].includes(opt.key)
);

export class Lead extends React.Component {
  constructor(props) {
    super(props);
    this.forms = {};
    this.div = {};

    this.limit = 100;
    var zipCodes = (props.auth.user.zipCodes || "")
      .split(",")
      .map((e) => e.trim())
      .map((e) => ({ key: e, text: e }));
    this.state = {
      showAssignDialog: false,
      isEditingAssign: false,
      showCustomerDialog: false,
      isEditingCustomer: false,
      searchText: "",
      // filter: "all",
      customers: [],
      staffs: [],
      closers: [],
      vendors: [],
      chosenCustomer: {},
      isLoading: false,
      hasMore: true,
      zipCodes: zipCodes,
      filterZipCodes: [],
      total: 0,
      filterYearStart: 0,
      filterYearEnd: 0,
      filterStaff: "all",
      filterCloser: "all",
      filterVendor: "all",
      dateRangeOptions: (() => {
        var result = [];
        for (var i = 1900; i <= new Date().getFullYear(); i++) {
          result.push({
            text: i.toString(),
            key: i,
          });
        }
        return result;
      })(),
      patientAssign: _.get(props, "location.state.pa", ""),
      filterPA: "",
      activeLink: "",
      headerFilters: {},
      openHeaderFilters: true,
      openWaitModal: false,
      waitModalInputs: {},
    };

    this.handleGetColumnConfig = this.handleGetColumnConfig.bind(this);
    this.renderHeaderFilter = this.renderHeaderFilter.bind(this);
    this.handleOpenWaitModal = this.handleOpenWaitModal.bind(this);
    this.handleSetWaitTime = this.handleSetWaitTime.bind(this);
    this.handleUpdateWaitModalInputs = this.handleUpdateWaitModalInputs.bind(
      this
    );
    this.handleCloseWaitModal = this.handleCloseWaitModal.bind(this);
    this.refreshCustomerList = this.refreshCustomerList.bind(this);
    this.closeDialog = this.closeDialog.bind(this);
    this.updateStateCallback = this.updateStateCallback.bind(this);
    this.fetch = this.fetch.bind(this);
  }

  hiddenForm(e) {
    if (e == this.selectedItem) {
      this.selectedItem && this.forms[e._id].hide();
      // this.selectedItem && this.resetBgDiv(this.div[e._id])
      this.tmpSelectedItem = this.selectedItem;
      // this.scrollToItem(e);
      this.backToPossitionScroll();
      this.selectedItem = null;
      //window.history.replaceState("", "", "/lead");
    }
  }

  componentDidMount() {
    axios.get(`${config.apiUrl}/zipcode/ofme`).then(({ data }) => {
      this.setState({
        zipCodes: data,
        chosenCustomer: {
          processResults: "LE",
          zipCode: (data[0] || {}).key,
        },
      });
    });

    axios.get(`${config.apiUrl}/user/list`).then(({ data }) => {
      this.setState({
        staffs: data
          .filter((e) => e.accountType === "staff")
          .map((e) => ({ key: e._id, text: e.email })),
        closers: data
          .filter((e) => e.accountType === "closer")
          .map((e) => ({
            key: e._id,
            text: `${e.fname} ${e.lname} | ${e.email}`,
          })),
      });
    });

    axios.get(`${config.apiUrl}/organization/list?orgtype=vendor&registrationConfirmed=true`).then(({ data }) => {
      this.setState({
        vendors: data
          .map((e) => ({ key: e._id, text: e.name }))
      });
    });

    //Fix issue about tabindx.
    this.FocusZoomKeyDown = FocusZone.prototype._onKeyDownCapture;
    FocusZone.prototype._onKeyDownCapture = function () { };
    this.fetch("", 0, () => {
      if (null != this.props.location) {
        const id = this.props.location.query.id;
        if (id) {
          axios.get(`${config.apiUrl}/customer/get/${id}`).then(({ data }) => {
            let f = this.state.customers.find((c) => c._id == data._id);
            if (!f) {
              const customers = [data].concat(this.state.customers);
              f = data;
              this.setState(
                {
                  customers,
                },
                () => {
                  setTimeout(() => {
                    this.selectItem(f);
                  }, 500);
                }
              );
            } else {
              let customers = this.state.customers.filter(
                (e) => e._id != data._id
              );
              customers = [f].concat(customers);
              this.setState(
                {
                  customers,
                },
                () => {
                  setTimeout(() => {
                    this.selectItem(f);
                  }, 500);
                }
              );
            }
          });
        }
      }
    });

    this.setState({ activeLink: _.get(this.props, "location.pathname") });
  }

  componentWillUnmount() {
    FocusZone.prototype._onKeyDownCapture = this.FocusZoomKeyDown;
  }

  componentWillReceiveProps(newProps) {
    if (newProps.searchBox !== this.props.searchBox) {
      this.setState(
        {
          customers: [],
          hasMore: true,
        },
        () => this.fetch(newProps.searchBox, 0)
      );
    }
  }

  componentDidUpdate(prevProps) {
    if (
      _.get(this.props, "location.state.pa") !==
      _.get(prevProps, "location.state.pa")
    ) {
      this.setState(
        {
          patientAssign: _.get(this.props, "location.state.pa", ""),
        },
        () => {
          this.fetch(this.props.searchBox, 0);
        }
      );
    }

    if (
      _.get(this.props, "location.pathname") !==
      _.get(prevProps, "location.pathname")
    ) {
      this.setState({ activeLink: _.get(this.props, "location.pathname") });
    }
  }

  _onFilterChanged(filterText, list) {
    if (null == this.state.zipCodes) {
      return [];
    }

    var check = {};
    (list || []).forEach((e) => (check[e.key] = true));

    var ftext = filterText.trim().toLowerCase();
    var result = [];

    for (let zipcode of this.state.zipCodes) {
      var tag = zipcode;
      if (tag.indexOf(ftext) === 0 && !check[tag]) {
        result.push(tag);
        if (result.length >= 20) break;
      }
    }

    result = result.map((e) => {
      return {
        key: e,
        name: e,
      };
    });

    return result;
  }

  fetch(text, skip, cb) {

    if (this.state.isLoading) {
      return;
    }
    this.setState({
      isLoading: true,
    });

    const commonParams = {
      process: "LE",
      pa: this.state.filterPA || PATIENT_ASSIGNMENT.HOME_HEALTH,
      zipCodes: this.state.filterZipCodes.map((e) => e.key),
      filterSearch:
        text == undefined || text == null
          ? this.props.searchBox.filter || ""
          : text.filter,
      q:
        text == undefined || text == null
          ? this.props.searchBox.text || ""
          : text.text,
      staffAssignedId:
        this.state.filterStaff == "all" ? "" : this.state.filterStaff,
      assignedToCloserId:
        this.state.filterCloser == "all" ? "" : this.state.filterCloser,
      assignedToVendorId:
        this.state.filterVendor == "all" ? "" : this.state.filterVendor,
      filterYearStart: this.state.filterYearStart,
      filterYearEnd: this.state.filterYearEnd,
      filterLastName: this.state.headerFilters.lastName,
      filterFirstName: this.state.headerFilters.firstName,
      filterAddress: this.state.headerFilters.address,
      filterCity: this.state.headerFilters.city,
      filterPhone: this.state.headerFilters.phone,
      filterStaff: this.state.headerFilters.staff,
      filterCloser: this.state.headerFilters.closer,
      filterCloserAssignedStart: this.state.headerFilters.closerAssignStart,
      filterCloserAssignedEnd: this.state.headerFilters.closerAssignEnd,
      ...((_.get(this.props, "location.pathname") === ROUTE.WAIT_LIST && {
        isWaitPage: true,
      }) ||
        (_.get(this.props, "location.pathname") === ROUTE.ASSIGNED_CLOSER && {
          isAssignedCloserPage: true,
        }) ||
        (_.get(this.props, "location.pathname") === ROUTE.ASSIGN_TO_CLOSER && {
          isCentralPage: true,
        }) ||
        (_.get(this.props, "location.pathname") === ROUTE.ASSIGN_TO_VENDOR && {
          isAssignVendor: true,
        }) ||
        (_.get(this.props, "location.pathname") === ROUTE.ASSIGNED_VENDOR && {
          isVendorAssigned: true,
        }) ||
        (_.get(this.props, "location.pathname") === ROUTE.SERVICE_PENDING && {
          isServicePending: true,
        })),

    };
    axios
      .get(`${config.apiUrl}/customer/list`, {
        params: {
          ...commonParams,
          limit: this.limit,
          skip: skip != undefined ? skip : this.state.customers.length,
        },
        user: this.props.auth.user,
      })
      .then(({ data }) => {
        const duplicatedCusts = _.intersectionBy(
          data,
          this.state.customers,
          "_id"
        );
        const filtCustomers = data.filter(
          (e) => !duplicatedCusts.some((c) => c._id === e._id)
        );
        const customers =
          skip === 0 ? data : this.state.customers.concat(filtCustomers);

        this.setState({
          customers: customers,
          isLoading: false,
          hasMore: filtCustomers.length >= this.limit,
        });
        cb && cb();
      })
      .catch((ex) => {
        this.setState({
          isLoading: false,
          hasMore: false,
        });
        cb && cb();
      });

    axios
      .get(`${config.apiUrl}/customer/count`, {
        params: commonParams,
      })
      .then(({ data }) => {
        this.setState({
          total: data.total,
        });
      })
      .catch((ex) => { });
  }

  changeFilterStaff(v) {
    this.setState(
      {
        filterStaff: v.key,
        customers: [],
        hasMore: true,
      },
      () => this.fetch(this.props.searchBox, 0)
    );
  }

  changeFilterCloser(v) {
    this.setState(
      {
        filterCloser: v.key,
        customers: [],
        hasMore: true,
      },
      () => this.fetch(this.props.searchBox, 0)
    );
  }

  changeFilterVendor(v) {
    this.setState(
      {
        filterVendor: v.key,
        customers: [],
        hasMore: true,
      },
      () => this.fetch(this.props.searchBox, 0)
    );
  }

  changeFilterYear(start, end) {
    this.setState(
      {
        filterYearStart: start,
        filterYearEnd: end,
        customers: [],
        hasMore: true,
      },
      () => {
        this.fetch(this.props.searchBox, 0);
      }
    );
  }

  changeFilterByZipCodes(items) {
    this.setState(
      {
        customers: [],
        hasMore: true,
        filterZipCodes: [].concat(items),
      },
      () => {
        this.fetch(this.props.searchBox, 0);
      }
    );
  }

  selectItem(e) {
    try {
      var selection = window.getSelection();
      if (selection.toString().length > 0) {
        return;
      }
    } catch (ex) { }

    if (this.selectedItem != e) {
      this.tmpSelectedItem &&
        this.resetBgDiv(this.div[this.tmpSelectedItem._id]);
      this.selectedItem && this.resetBgDiv(this.div[this.selectedItem._id]);
      this.selectedItem && this.forms[this.selectedItem._id].hide();
      this.forms[e._id].show();
      this.changeBgDiv(this.div[e._id]);
      this.scrollY = window.scrollY;
      this.selectedItem = e;
      this.tmpSelectedItem = null;
      window.history.replaceState("", "", _.get(this.props, "location.pathname") + "?id=" + e._id);
    } else {
      this.selectedItem && this.resetBgDiv(this.div[this.selectedItem._id]);
      this.selectedItem && this.forms[this.selectedItem._id].hide();
      this.selectedItem = null;
      this.tmpSelectedItem = null;
      window.history.replaceState("", "", _.get(this.props, "location.pathname"));
    }

    this.forceUpdate();
  }

  hiddenForm(e) {
    if (e == this.selectedItem) {
      this.selectedItem && this.forms[e._id].hide();
      // this.selectedItem && this.resetBgDiv(this.div[e._id])
      this.tmpSelectedItem = this.selectedItem;
      // this.scrollToItem(e);
      this.backToPossitionScroll();
      this.selectedItem = null;
      //window.history.replaceState("", "", "/lead");
    }
  }

  backToPossitionScroll() {
    window.scrollTo(0, this.scrollY);
  }

  scrollToItem(e) {
    var div = this.div[e._id];
    div.scrollIntoView();
    window.scrollTo(0, window.scrollY - 100);
  }

  resetBgDiv(div) {
    div.style.background = "";
  }

  changeBgDiv(div) {
    div.style.background = "#f0f0f0";
  }

  save(data) {

    const conf = {
      headers: {
        'content-type': 'multipart/form-data'
      },

    }

    var form_data = new FormData();

    for (var key in data) {
      if (data[key] !== undefined && data[key] !== null)
        form_data.append(key, data[key]);
    }

    if (this.state.insurancedoc !== undefined && this.state.insurancedoc !== null)
      for (let insurancedoc of this.state.insurancedoc.length) {
        form_data.append("insurancedoc", insurancedoc);
      }

    if (data.patientAssignment === PATIENT_ASSIGNMENT.SEND_BACK) {
      this.sendBackToCU(data);
    } else {
      axios
        .post(`${config.apiUrl}/customer/update`, form_data, conf)
        .then(({ data }) => {
          let customers = this.state.customers;
          const i = customers.findIndex((e) => e._id == data._id);
          if (i >= 0) {
            if (data.status === LEAD_STATUS.DELETED) {
              customers = customers.filter((cust) => cust._id !== data._id);
            } else {
              customers[i] = data;
            }
          } else {
            customers.push(data);

            setTimeout(() => {
              this.selectItem(data);
            }, 500);
          }
          this.resetPageData(customers);

        })
        .catch((ex) => {
          console.error(ex);
          // alert('Error');
        });
    }


  }

  saveExtras(data) {
    axios
      .post(`${config.apiUrl}/customer/update`, data)
      .then(({ data }) => {
        var i = this.state.customers.findIndex((e) => e._id == data._id);
        if (i >= 0) {
          this.state.customers[i] = data;
        } else {
          this.state.customers.push(data);

          setTimeout(() => {
            this.selectItem(data);
          }, 500);
        }
        this.setState({
          customers: [].concat(this.state.customers),
          showAssignDialog: false,
          chosenCustomer: {},
        });
      })
      .catch((ex) => {
        console.error(ex);
        // alert('Error');
      });

  }
  showAssignDialog() {
    this.setState({
      showAssignDialog: true,
      isEditingAssign: false,
    });
  }

  assignCustomer(data, evt, action) {
    evt && evt.stopPropagation && evt.stopPropagation();
    let chosenCustomer = {
      _id: data._id,
      assignedToCloserId: data.assignedToCloserId || "",
      assignedToCloserAt: new Date(),
      assignedToCloserById: this.props.auth.user._id,
    };

    if (action == ROUTE.ASSIGN_TO_VENDOR)
      chosenCustomer.assignedToVendorId = data.assignedToVendorId || data.lastServedVendorId || "";

    this.setState({
      showAssignDialog: true,
      isEditingAssign: true,
      chosenCustomer: chosenCustomer
    });
  }

  showDialog() {
    this.setState({
      showCustomerDialog: false,
      isEditingCustomer: false,
    });
  }


  markAsServed(data, evt) {
    evt && evt.stopPropagation && evt.stopPropagation();
    this.setState({
      showAssignDialog: true,
      isEditingAssign: true,
      chosenCustomer: {
        _id: data._id,
        leadClass: "served",
        serviceStartDate: data.serviceStartDate || new Date(),
        serviceEndDate: data.serviceEndDate || new Date(),
        lastServedVendorId: data.assignedToVendorId,
        isCloserVerified: false,
        isVendorApproved: false,
        assignedToVendorId: null,
        assignedToCloserId: null,
        vendorApprovedDate: null,
        patientAssignment: null,
        isServed: false
      },
    });
  }


  closeDialog() {
    this.setState({
      showAssignDialog: false,
      showCustomerDialog: false,
      chosenCustomer: {},
      editCustomer: {}
    });
  }

  editCustomer(data, evt) {
    evt && evt.stopPropagation && evt.stopPropagation();

    this.setState({
      showCustomerDialog: true,
      isEditingCustomer: true,
      chosenCustomer: data
    });
  }

  updateStateCallback(e, cb = () => { }) {

    this.setState(e, cb);
  }

  refreshCustomerList(data) {
    let customers = this.state.customers;
    const i = customers.findIndex((e) => e._id == data._id);
    if (i >= 0) {
      if (data.status === LEAD_STATUS.DELETED) {
        customers = customers.filter((cust) => cust._id !== data._id);
      } else {
        customers[i] = data;
      }
    } else {
      customers.push(data);

    }
    this.resetPageData(customers);

  }
  valueChange(key, v) {
    var chosenCustomer = this.state.chosenCustomer;
    chosenCustomer[key] = v;
    this.setState({
      chosenCustomer: { ...chosenCustomer },
    });
  }

  print(e, evt) {
    evt && evt.stopPropagation && evt.stopPropagation();
    var url =
      config.apiUrl +
      "/customer/pdf/" +
      e._id +
      "?token=" +
      this.props.auth.user.token;
    var win = window.open(url);
    win.focus();
  }

  handleGetColumnConfig(isVendor, isCloser) {

    let columns = CENTRAL_DASHBOARD_COLUMNS.filter((col) =>
      col.key === "assignedToCloserAt" && _.get(this.props, "location.pathname") === ROUTE.ASSIGNED_CLOSER
      || col.key !== "assignedToCloserAt")

    return columns.map((col) => {
      if (col.key === "moveToWait") {
        col.onRender = (item) => {
          return (
            item.key !== "filterRow" && (
              <div>
                {item.reminderDate && (
                  <div style={{ marginBottom: 5, color: "red", fontSize: 12 }}>
                    <div>{"Due date: "}</div>
                    <div>{moment(item.reminderDate).format("MMM DD YYYY")}</div>
                  </div>
                )}
                <button
                  onClick={() => this.handleOpenWaitModal(item)}
                  className="tbl-btn"
                  style={{
                    border: "1px solid red",
                    borderRadius: 5,
                    color: "red",
                  }}
                >
                  {item.reminderDate ? "Update" : "Wait"}
                </button>
              </div>
            )
          );
        };
      } else if (col.key === "process" && !isCloser) {
        col.onRender = (item) => {
          return (
            item.key !== "filterRow"

            && (
              <div>

                {(_.get(this.props, "location.pathname") === ROUTE.SERVICE_PENDING
                  || (_.get(this.props, "location.pathname") === ROUTE.ASSIGNED_VENDOR && isVendor && !item.isVendorApproved)
                  || (_.get(this.props, "location.pathname") === ROUTE.ASSIGNED_VENDOR && _.get(this.props, "auth.user.accountType") === USER_TYPE.CENTRAL_USER)
                  || (_.get(this.props, "location.pathname") === ROUTE.ASSIGNED_VENDOR && _.get(this.props, "auth.user.accountType") === USER_TYPE.ADMIN)
                  || _.get(this.props, "location.pathname") === ROUTE.ASSIGN_TO_VENDOR
                  || (_.get(this.props, "location.pathname") === ROUTE.WAIT_LIST && _.get(this.props, "auth.user.accountType") === USER_TYPE.CENTRAL_USER)
                  || (_.get(this.props, "location.pathname") === ROUTE.WAIT_LIST && _.get(this.props, "auth.user.accountType") === USER_TYPE.ADMIN)
                  || _.get(this.props, "location.pathname") === ROUTE.ASSIGNED_CLOSER
                  || _.get(this.props, "location.pathname") === ROUTE.ASSIGN_TO_CLOSER
                  || _.get(this.props, "location.pathname") === ROUTE.SERVICE_PENDING
                ) && (
                    <button
                      className="tbl-btn"
                      onClick={(e) => this.reverseOneStep(item, e, _.get(this.props, "location.pathname"))}
                    >
                      <i className="ms-Icon ms-Icon--RevToggleKey" aria-hidden="true"></i>
                    </button>)
                }

                {_.get(this.props, "location.pathname") !== ROUTE.ASSIGNED_VENDOR &&
                  _.get(this.props, "location.pathname") !== ROUTE.SERVICE_PENDING && (<button
                    className="tbl-btn"
                    onClick={(e) => this.assignCustomer(item, e, _.get(this.props, "location.pathname"))}
                  >
                    <i className="ms-Icon ms-Icon--AddFriend" aria-hidden="true"></i>
                  </button>)
                }

                {_.get(this.props, "location.pathname") === ROUTE.ASSIGN_TO_VENDOR && (<button
                  className="tbl-btn"
                  onClick={(e) => this.editCustomer(item, e)}
                >
                  <i className="ms-Icon ms-Icon--Edit" aria-hidden="true"></i>
                </button>)}

                {_.get(this.props, "location.pathname") === ROUTE.ASSIGN_TO_VENDOR && (<button
                  className="tbl-btn"
                  onClick={(e) => this.markAsServed(item, e)}
                >
                  <i className="ms-Icon ms-Icon--Touch" aria-hidden="true"></i>
                </button>)
                }

                {_.get(this.props, "location.pathname") === ROUTE.SERVICE_PENDING && (<button
                  className="tbl-btn"
                  onClick={(e) => this.markAsServed(item, e)}
                >
                  <i className="ms-Icon ms-Icon--Touch" aria-hidden="true"></i>
                </button>)
                }

                {_.get(this.props, "location.pathname") === ROUTE.ASSIGNED_VENDOR && isVendor && !item.isVendorApproved && (
                  <button
                    className="tbl-btn"
                    onClick={(e) => this.approveAssignment(item, e)}
                  >

                    <i className="ms-Icon ms-Icon ms-Icon--Accept" aria-hidden="true"></i>
                  </button>
                )
                }
                {_.get(this.props, "location.pathname") === ROUTE.ASSIGNED_VENDOR && isVendor && !item.isVendorApproved && (
                  <button
                    className="tbl-btn"
                    onClick={(e) => this.disapproveAssignment(item, e)}
                  >

                    <i className="ms-Icon ms-Icon ms-Icon--Cancel" aria-hidden="true"></i>
                  </button>
                )
                }


              </div>
            )
          );
        };
      } else if (
        ["firstName", "lastName", "address", "assignedToCloserAt", "city", "phone", "staff"].includes(col.key)
      ) {
        const oldRender = col.onRender;
        col.onRender = (item) => {
          if (item.key === "filterRow") {
            return this.renderHeaderFilter(col);
          }
          return oldRender ? oldRender(item) : item[col.fieldName];
        };
      }

      return col;
    });
  }

  approveAssignment(data, evt) {
    evt && evt.stopPropagation && evt.stopPropagation();
    if (confirm("Do you want to approve this assignment?")) {
      axios
        .post(`${config.apiUrl}/customer/approve`, {
          _id: data._id,
        })
        .then(({ data }) => {
          let customers = this.state.customers;
          const i = customers.findIndex((e) => e._id == data._id);

          customers[i] = data;

          //this.rowSelected = null;
          this.setState({
            customers: customers,
          });
        })
        .catch((ex) => {
          alert("Error");
          s;
        });
    }
  }


  disapproveAssignment(data, evt) {
    evt && evt.stopPropagation && evt.stopPropagation();
    if (confirm("Do you want to disapprove this assignment??")) {
      axios
        .post(`${config.apiUrl}/customer/disapprove`, {
          _id: data._id,
        })
        .then(({ data }) => {
          var customers = this.state.customers.filter((e) => e._id != data._id);
          this.rowSelected = null;
          this.setState({
            customers: customers,
          });
        })
        .catch((ex) => {
          alert("Error");
          s;
        });
    }
  }

  reverseOneStep(data, evt, route) {

    let endpoint = "";
    switch (route) {
      case ROUTE.SERVICE_PENDING:
        endpoint = "reversetovendorassigned";
        break;
      case ROUTE.ASSIGNED_VENDOR:
        endpoint = "reversetoassignvendor";
        break;
      case ROUTE.ASSIGN_TO_VENDOR:
        endpoint = "reversetocloserassigned";
        break;
      case ROUTE.ASSIGNED_CLOSER:
        endpoint = "reversetoassigncloser";
        break;
      case ROUTE.ASSIGN_TO_CLOSER:
      case ROUTE.WAIT_LIST:
        endpoint = "reversetolead";
        break;

    }

    evt && evt.stopPropagation && evt.stopPropagation();
    if (confirm("Do you want to reverse this assignment?")) {
      axios
        .post(`${config.apiUrl}/customer/${endpoint}`, {
          _id: data._id,
        })
        .then(({ data }) => {

          var customers = this.state.customers.filter(
            (e) => e._id != data._id
          );

          this.setState(
            {
              customers: customers,
            }
          );

        })
        .catch((ex) => {
          alert("Error");
        });
    }


  }

  changeFilterPA(value) {
    this.setState(
      {
        filterPA: value,
      },
      () => {
        this.fetch(this.props.searchBox, 0);
      }
    );
  }

  renderHeaderFilter({ fieldName, name = "" }) {
    let timeout;

    if (fieldName === "assignedToCloserAt") {
      return (
        <StartEndDateFilter
          startDateField={"closerAssignStart"}
          endDateField={"closerAssignEnd"}
          fetch={this.fetch}
          searchBox={this.props.searchBox}
          headerFilters={this.state.headerFilters}
          updateStateCallback={this.updateStateCallback}
        />
      );

    }

    return (
      <TextField
        name={fieldName}
        placeholder={`Find ${name.toLowerCase()}`}
        value={this.state.headerFilters[fieldName]}
        onChanged={(value) => {
          if (timeout) {
            clearTimeout(timeout);
          }
          this.setState(
            {
              headerFilters: {
                ...this.state.headerFilters,
                [fieldName]: value,
              },
            },
            () => {
              timeout = setTimeout(() => {
                this.fetch(this.props.searchBox, 0);
              }, 300);
            }
          );
        }}
      />
    );
  }

  handleOpenWaitModal(row) {
    this.setState({
      openWaitModal: true,
      waitModalInputs: {
        _id: row._id,
        reminderDate: row.reminderDate || new Date(),
      },
    });
  }

  handleUpdateWaitModalInputs(newInputs) {
    this.setState(({ waitModalInputs }) => ({
      waitModalInputs: {
        ...waitModalInputs,
        ...newInputs,
      },
    }));
  }

  handleSetWaitTime() {
    const { waitModalInputs } = this.state;

    return axios
      .post(`${config.apiUrl}/customer/update`, waitModalInputs)
      .then(({ data }) => {
        if (data._id) {
          this.setState({
            customers: this.state.customers.map((cust) => {
              if (cust._id === data._id) {
                return data;
              }
              return cust;
            }),
          });
        }
        return true;
      })
      .catch((ex) => {
        console.error("[ERROR - /customer/update]:", ex);
        alert("Request updating customer failed!");

        return true;
      });
  }

  handleCloseWaitModal() {
    this.setState({
      openWaitModal: false,
      waitModalInputs: {},
    });
  }

  resetPageData(customers) {
    this.setState({
      customers: customers && customers.length > 0 ? customers : [],
      showCustomerDialog: false,
      chosenCustomer: {
        processResults: "LE",
        zipCode: (this.state.zipCodes[0] || {}).key,
      },
      insurancedoc: null
    });
  }

  render() {
    const {
      isLoading,
      hasMore,
      customers,
      chosenCustomer,
      filterStaff,
      filterCloser,
      filterVendor,
      total,
      staffs,
      closers,
      vendors,
      activeLink,
      openHeaderFilters,
    } = this.state;
    var user = this.props.auth.user;
    const isVendor = user.orgType == 'vendor';
    const isCloser = user.accountType == 'closer';
    const columns = this.handleGetColumnConfig(isVendor, isCloser);

    const isCentralPage =
      _.get(this.props, "location.state.isCentral") ||
      _.get(this.props, "auth.user.accountType") === USER_TYPE.CENTRAL_USER ||
      _.get(this.props, "auth.user.accountType") === USER_TYPE.ADMIN;

    console.log("isCentralPage = ")
    console.log(isCentralPage)


    const isCloserPage =
      _.get(this.props, "location.state.isCloser") ||
      _.get(this.props, "auth.user.accountType") === USER_TYPE.CLOSER;

    // render HTML
    return (
      <div style={{ margin: 10 }}>
        <div style={{ marginTop: 10 }}>

          {isVendor && (
            <Pivot
              aria-label="Vendor Dashboard - Section Tabs"
              linkSize={PivotLinkSize.normal}
              onLinkClick={(tab) => {
                history.push(tab.props.itemKey);
              }}
              selectedKey={activeLink}
            >

              <PivotItem
                itemKey={ROUTE.ASSIGNED_VENDOR}
              />

            </Pivot>)
          }
          {!isVendor && !isCloser && (
            <Pivot
              aria-label="Central Dashboard - Section Tabs"
              linkSize={PivotLinkSize.large}
              onLinkClick={(tab) => {
                history.push(tab.props.itemKey);
              }}
              selectedKey={activeLink}
            >
              <PivotItem
                itemKey={ROUTE.ASSIGN_TO_CLOSER}
                linkText="To Be Assigned to Closer"
              />
              <PivotItem
                itemKey={ROUTE.ASSIGNED_CLOSER}
                linkText="Closer Assigned"
              />
              <PivotItem itemKey={ROUTE.WAIT_LIST} linkText="Wait List" />
              <PivotItem
                itemKey={ROUTE.ASSIGN_TO_VENDOR}
                linkText="To Be Assigned to Vendor"
              />
              <PivotItem
                itemKey={ROUTE.ASSIGNED_VENDOR}
                linkText="Vendor Assigned"
              />
              <PivotItem
                itemKey={ROUTE.SERVICE_PENDING}
                linkText="Service Pending"
              />
            </Pivot>)
          }

          {!isVendor && isCloser && (
            <Pivot
              aria-label="Central Dashboard - Section Tabs"
              linkSize={PivotLinkSize.large}
              onLinkClick={(tab) => {
                history.push(tab.props.itemKey);
              }}
              selectedKey={activeLink}
            >

              <PivotItem
                itemKey={ROUTE.ASSIGN_TO_VENDOR}
                linkText="To Be Assigned to Vendor"
              />
              <PivotItem
                itemKey={ROUTE.ASSIGNED_VENDOR}
                linkText="Vendor Assigned"
              />
            </Pivot>)
          }


        </div>
        <div style={{ marginTop: 10 }}>
          <Pivot
            aria-label="Central Dashboard - PA Tabs"
            onLinkClick={(tab) => {
              this.changeFilterPA(tab.props.itemKey);
            }}
          >
            {PAGE_PA_LIST.map((opt) => (
              <PivotItem key={opt.key} itemKey={opt.key} linkText={opt.text} />
            ))}
          </Pivot>
        </div>
        <div style={{ marginTop: 20, marginBottom: 10 }}>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-between",
            }}
          >
            {activeLink === ROUTE.ASSIGNED_VENDOR && !isVendor && (
              <div style={{ width: 300 }} className="one-line-100">
                <Dropdown
                  label="Filter by Vendor"
                  selectedKey={filterVendor}
                  options={[{ key: "all", text: "All" }].concat(vendors)}
                  onChanged={(v) => this.changeFilterVendor(v)}
                />
              </div>
            )}

            {activeLink !== ROUTE.ASSIGNED_VENDOR && (
              <div style={{ width: 300 }} className="one-line-100">
                <Dropdown
                  label="Filter by Lead Generator"
                  selectedKey={filterStaff}
                  options={[{ key: "all", text: "All" }].concat(staffs)}
                  onChanged={(v) => this.changeFilterStaff(v)}
                />
              </div>
            )}

            {activeLink == ROUTE.ASSIGNED_CLOSER && (
              <div style={{ width: 300 }} className="one-line-100">
                <Dropdown
                  label="Filter by Closer"
                  selectedKey={filterCloser}
                  options={[{ key: "all", text: "All" }].concat(closers)}
                  onChanged={(v) => this.changeFilterCloser(v)}
                />
              </div>
            )}
            <div
              style={{
                display: "flex",
                marginBottom: 10,
                marginLeft: 50,
                alignItems: "center",
              }}
            >
              <div style={{ marginRight: 20 }}>Filter by ZipCodes</div>
              <TagPicker
                ref="zipCodes"
                onResolveSuggestions={this._onFilterChanged.bind(this)}
                onChange={(items) => this.changeFilterByZipCodes(items)}
                getTextFromItem={(item) => {
                  return item.name;
                }}
                onRenderSuggestionsItem={(item) => (
                  <span
                    style={{
                      color: item.needReAssign ? "blue" : "",
                      fontWeight: item.needReAssign ? "600" : "",
                    }}
                  >
                    {item.name}
                  </span>
                )}
                pickerSuggestionsProps={{
                  suggestionsHeaderText: "Zip Codes",
                  noResultsFoundText: "No Zip Code Found",
                }}
                defaultSelectedItems={this.filterZipCodes}
              />
            </div>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "flex-end",
              }}
            >
              <div
                style={{ width: 180, marginLeft: 50 }}
                className="one-line-100"
              >
                <Dropdown
                  label="Year of Birth"
                  selectedKey={this.state.filterYearStart}
                  options={[{ key: 0, text: "--" }].concat(
                    this.state.dateRangeOptions
                  )}
                  onChanged={(v) =>
                    this.changeFilterYear(
                      v.key < this.state.filterYearEnd ||
                        v.key === 0 ||
                        this.state.filterYearEnd == 0
                        ? v.key
                        : this.state.filterYearStart,
                      this.state.filterYearEnd
                    )
                  }
                />
              </div>
              <div
                style={{ width: 130, marginLeft: 20 }}
                className="one-line-50"
              >
                <Dropdown
                  label="to"
                  style={{ width: 100 }}
                  selectedKey={this.state.filterYearEnd}
                  options={[{ key: 0, text: "--" }].concat(
                    this.state.dateRangeOptions
                  )}
                  onChanged={(v) =>
                    this.changeFilterYear(
                      this.state.filterYearStart,
                      v.key > this.state.filterYearStart ||
                        v.key == 0 ||
                        this.state.filterYearStart == 0
                        ? v.key
                        : this.state.filterYearEnd
                    )
                  }
                />
              </div>
            </div>
          </div>
        </div>
        <InfiniteScroll
          pageStart={0}
          loadMore={() => this.fetch()}
          useWindow={true}
          initialLoad={false}
          style={{ marginBottom: 30 }}
          loader={
            isLoading ? (
              <Spinner key={1} size={SpinnerSize.large} />
            ) : (
              <span key={2}></span>
            )
          }
          hasMore={hasMore}
        >
          <DetailsList
            setKey={"_id"}
            items={[
              ...(openHeaderFilters ? [{ key: "filterRow" }] : []),
              ...customers,
            ]}
            columns={columns}
            selectionPreservedOnEmptyClick={true}
            selectionMode={SelectionMode.none}
            onColumnHeaderClick={() =>
              this.setState({
                openHeaderFilters: !this.state.openHeaderFilters,
              })
            }
            onRenderRow={(props) => {
              return (
                <div
                  style={{
                    borderBottom: "1px solid #e6e6e6",
                    background:
                      props.item.key === "filterRow"
                        ? "rgba(240, 240, 240, 1)"
                        : "",
                  }}
                >
                  <div
                    ref={(e) => (this.div[props.item._id] = e)}
                    onClick={() =>
                      props.item.key !== "filterRow" &&
                      this.selectItem(props.item)
                    }
                    className="row-hover"
                  >
                    <DetailsRow {...props} />
                    {props.item.key !== "filterRow" && (
                      <div
                        style={{ padding: "0 0 10px 8px" }}
                        className="ms-fontColor-themePrimary"
                      >
                        {props.item.patientAssignment && (
                          <div style={{ marginBottom: 10, fontWeight: "bold" }}>
                            {_.get(
                              PATIENT_ASSIGNMENT_LIST.find(
                                (opt) =>
                                  opt.key === props.item.patientAssignment
                              ),
                              "text",
                              ""
                            )}
                          </div>
                        )}
                        {props.item.leadCategory && (
                          <div style={{ marginBottom: 10 }}>
                            <span style={{ fontWeight: "bold" }}>
                              {_.get(
                                LEAD_CATEGORY_LIST.find(
                                  (opt) => opt.key === props.item.leadCategory
                                ),
                                "text",
                                ""
                              )}
                            </span>
                            {props.item.closerRemind && (
                              <span>
                                {" - Remind at "}
                                <span
                                  style={{ color: "red", fontWeight: "bold" }}
                                >
                                  {moment(props.item.closerRemind).format(
                                    "MMM DD YYYY"
                                  )}
                                </span>
                              </span>
                            )}
                          </div>
                        )}
                        {props.item.assignedToCloser && !isVendor && (
                          <div style={{ fontWeight: "600" }}>
                            {`Closer: ${props.item.assignedToCloser.fname} ${props.item.assignedToCloser.lname} | ${props.item.assignedToCloser.email}`}
                          </div>
                        )}
                        {props.item.assignedToVendor && !isVendor  && (
                          <div style={{ fontWeight: "600" }}>
                            {`Vendor: ${props.item.assignedToVendor.name} | ${props.item.assignedToVendor.contactEmail}`}
                          </div>
                        )}
                        <div>
                          {props.item.comments ? (
                            props.item.comments
                          ) : (
                            <i>No comments</i>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                  {props.item.key !== "filterRow" && (isCentralPage || isCloserPage || isVendor) && (
                    <LeadForm
                      ref={(e) => (this.forms[props.item._id] = e)}
                      data={props.item}
                      insurancedoc={props.item.insurancedoc}
                      onCancel={() => this.hiddenForm(props.item)}
                      onSave={(data) => this.save(data)}
                      token={this.props.auth.user.token}
                      isVendor={isVendor}
                    />
                  )}

                  {props.item._id === this.state.chosenCustomer._id && (isCentralPage || isVendor) && _.get(this.props, "location.pathname") === ROUTE.ASSIGN_TO_VENDOR && this.state.showCustomerDialog && (
                    <CustomerAddEditForm
                      showDialog={this.state.showCustomerDialog}
                      isEditing={this.state.isEditingCustomer}
                      closers={this.state.closers}
                      closeDialog={this.closeDialog}
                      theCustomer={props.item}
                      refreshCustomerList={this.refreshCustomerList}
                      isCloserPage={isCloserPage} />
                  )

                  }
                </div>
              );
            }}
          />
        </InfiniteScroll>
        <StatusBar>
          <span>Total: {total}</span>
          {this.selectedItem && (
            <span>
              {" "}
              | Selected: #{customers.indexOf(this.selectedItem) + 1} -{" "}
              {`${this.selectedItem.firstName} ${this.selectedItem.lastName}`}{" "}
            </span>
          )}
        </StatusBar>
        {_.get(this.props, "location.pathname") === ROUTE.ASSIGN_TO_VENDOR && (
          <Dialog
            isOpen={this.state.showAssignDialog}
            type={DialogType.normal}
            onDismiss={() => this.closeDialog()}
            title="Assign to Vendor"
            isBlocking={true}
            containerClassName="relative-info"
          >
            <div className="ms-Grid">
              <div className="one-line-150">
                <Dropdown
                  label="Vendors"
                  options={this.state.vendors}
                  selectedKey={chosenCustomer.assignedToVendorId || ""}
                  onChanged={(v) => this.valueChange("assignedToVendorId", v.key)}
                />
              </div>
            </div>

            <DialogFooter>

              <PrimaryButton onClick={() => this.saveExtras(chosenCustomer)}>
                Save
              </PrimaryButton>)

              <DefaultButton onClick={() => this.closeDialog()}>
                Cancel
              </DefaultButton>
            </DialogFooter>
          </Dialog>


        )}

        {_.get(this.props, "location.pathname") !== ROUTE.ASSIGN_TO_VENDOR &&
          _.get(this.props, "location.pathname") !== ROUTE.ASSIGNED_VENDOR && (
            <Dialog
              isOpen={this.state.showAssignDialog}
              type={DialogType.normal}
              onDismiss={() => this.closeDialog()}
              title={this.state.isEditingAssign ? "Assign to Closer" : "Add new customer"}
              isBlocking={true}
              containerClassName="relative-info"
            >
              <div className="ms-Grid">
                <div className="one-line-150">
                  <Dropdown
                    label="Closers"
                    options={this.state.closers}
                    selectedKey={chosenCustomer.assignedToCloserId}
                    onChanged={(v) => this.valueChange("assignedToCloserId", v.key)}
                  />
                </div>
              </div>

              <DialogFooter>
                <PrimaryButton onClick={() => this.saveExtras(chosenCustomer)}>
                  Save
                </PrimaryButton>
                <DefaultButton onClick={() => this.closeDialog()}>
                  Cancel
                </DefaultButton>
              </DialogFooter>
            </Dialog>


          )}
        {_.get(this.props, "location.pathname") === ROUTE.SERVICE_PENDING && (
          <Dialog
            isOpen={this.state.showAssignDialog}
            type={DialogType.normal}
            onDismiss={() => this.closeDialog()}
            title="Confirm as served"
            isBlocking={true}
            containerClassName="relative-info"
          >
            <div className="ms-Grid">
              <div className="one-line-150">
                <DatePicker
                  className="one-line-150"
                  label="Service Start Date"
                  value={
                    chosenCustomer.serviceStartDate ? new Date(chosenCustomer.serviceStartDate) : null
                  }
                  onSelectDate={(v) => this.valueChange("serviceStartDate", v)}
                  formatDate={(date) => moment(date).format("MMM DD YYYY")}
                  allowTextInput
                />
                <DatePicker
                  className="one-line-150"
                  label="Service End Date"
                  value={
                    chosenCustomer.serviceEndDate ? new Date(chosenCustomer.serviceEndDate) : null
                  }
                  onSelectDate={(v) => this.valueChange("serviceEndDate", v)}
                  formatDate={(date) => moment(date).format("MMM DD YYYY")}
                  allowTextInput
                />
              </div>
            </div>

            <DialogFooter>
              <PrimaryButton onClick={() => this.saveExtras(chosenCustomer)}>
                Save
              </PrimaryButton>
              <DefaultButton onClick={() => this.closeDialog()}>
                Cancel
              </DefaultButton>
            </DialogFooter>
          </Dialog>


        )}

        <MoveToWaitModal
          isOpen={this.state.openWaitModal}
          inputs={this.state.waitModalInputs}
          updateInputs={this.handleUpdateWaitModalInputs}
          submitForm={this.handleSetWaitTime}
          onClose={this.handleCloseWaitModal}
        />
      </div>
    );
  }
}

export default connect((state) => ({
  auth: state.auth,
  searchBox: state.app.searchBox || { filter: "", text: "" },
}))(Lead);



// WEBPACK FOOTER //
// ./client/components/CUAssignToCloser.js